import { random } from 'lodash'
import React from 'react'

export type Notification = {
  message: string
  type: string
}

export type NotificationStore = Notification & {
  messageId: number
}

interface NotificationContextType {
  notification: NotificationStore
  sendNotification: (notification: Notification) => void
}

const defaultState: NotificationStore = { message: '', type: 'success', messageId: 1 }

export const NotificationContext = React.createContext<NotificationContextType>({
  notification: defaultState,
  sendNotification: () => {}
})

interface Props {
  children: React.ReactNode
}

export function NotificationProvider({ children }: Props): JSX.Element {
  const [notification, setNotification] = React.useState<NotificationStore>(defaultState)

  const sendNotification = React.useCallback(({ message, type }: Notification) => {
    setNotification({ message, type, messageId: random(0, 200000) })
  }, [])

  return (
    <NotificationContext.Provider value={{ notification, sendNotification }}>
      {children}
    </NotificationContext.Provider>
  )
}

export function useNotification(): NotificationContextType {
  return React.useContext(NotificationContext)
}
